import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Rym() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Sweetalert.js", "", "", "", "", ""];
    const infoProyect = [
        "Rick and Morty Versus",
        "https://www.youtube.com/embed/rZFvIy9E2-s",
        "In this mini game you can put two players to fight by selecting their names",
        "https://brandongrimaldom.github.io/rymversus/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Rym;